import React from "react"
import { useTranslation } from "react-i18next"
import ButtonFilter from "../../../../shared/components/buttons/ButtonFilter"
import { MeetingStatuses } from "../../../meeting/state/meetingTypes"
import { ISearchQuery, ISetSearchQueryFunction } from "../../../../shared/hooks/useSearch"

interface Props {
  searchQuery: ISearchQuery,
  setSearchQuery: ISetSearchQueryFunction
}

const MeetingFilter: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation(["meeting"])

  const checkAllIsOn = () => {
    return props.searchQuery.appliedFilters.length == 0
  }

  const checkIsOn = (filter) => {
    return props.searchQuery.appliedFilters.includes(filter)
  }

  const resetFilters = () => {
    if (!checkAllIsOn()) {
      props.setSearchQuery({ appliedFilters: [] })
    }
  }

  const updateFilters = (filter) => {
    const isOn = checkIsOn(filter)
    if (isOn) {
      props.setSearchQuery({
        appliedFilters: props.searchQuery.appliedFilters.filter(i => i !== filter)
      })
    } else {
      props.setSearchQuery({
        appliedFilters: [...props.searchQuery.appliedFilters, filter]
      })
    }
  }

  return (
    <ul className="flex flex-wrap">
      <li className="mb-2 mr-2">
        <ButtonFilter isOn={checkAllIsOn()} action={() => { resetFilters() }}>
          {t("meeting:all")}
        </ButtonFilter>
      </li>
      <li className="mb-2 mr-2">
        <ButtonFilter isOn={checkIsOn(MeetingStatuses.Scheduled)} action={() => { updateFilters(MeetingStatuses.Scheduled) }}>
          {t("meeting:scheduled")}
        </ButtonFilter>
      </li>
      <li className="mb-2 mr-2">
        <ButtonFilter isOn={checkIsOn(MeetingStatuses.InProgress)} action={() => { updateFilters(MeetingStatuses.InProgress) }}>
          {t("meeting:inProgress")}
        </ButtonFilter>
      </li>
      <li className="mb-2 mr-2">
        <ButtonFilter isOn={checkIsOn(MeetingStatuses.Ended)} action={() => { updateFilters(MeetingStatuses.Ended) }}>
          {t("meeting:ended")}
        </ButtonFilter>
      </li>
      <li className="mb-2 mr-2">
        <ButtonFilter isOn={checkIsOn(MeetingStatuses.Cancelled)} action={() => { updateFilters(MeetingStatuses.Cancelled) }}>
          {t("meeting:cancelled")}
        </ButtonFilter>
      </li>
    </ul>
  )
}

export default MeetingFilter
